"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetChildInfoAllOfApiKeysV3 {
    static getAttributeTypeMap() {
        return GetChildInfoAllOfApiKeysV3.attributeTypeMap;
    }
}
GetChildInfoAllOfApiKeysV3.discriminator = undefined;
GetChildInfoAllOfApiKeysV3.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    }
];
exports.GetChildInfoAllOfApiKeysV3 = GetChildInfoAllOfApiKeysV3;
//# sourceMappingURL=getChildInfoAllOfApiKeysV3.js.map